import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-annakshetra-summary-report',
  templateUrl: './annakshetra-summary-report.component.html',
  styleUrls: ['./annakshetra-summary-report.component.scss']
})
export class AnnakshetraSummaryReportComponent implements OnInit {

  public summaryReport: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public payment_status = 'paid';
  public maxDate = '';

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService
  ) { }

  ngOnInit() {
    this.getReport();
  }

  getReport() {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    
    this.apiService.getDataFromServer(`/annakshetra_summary_report?from_date=${from_date}&end_date=${to_date}&payment_status=${this.payment_status}`).subscribe(
      (res: any) => {
        this.appComponent.hideLoader();
        this.summaryReport = res.data;
      },
      err => {
        this.appComponent.hideLoader();
        console.log(err);
      }
    );
  }

  exportData() {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    
    this.apiService.getDataFromServer(`/export_annakshetra_summary_report?from_date=${from_date}&end_date=${to_date}&payment_status=${this.payment_status}`).subscribe((res: any) => {
      if(res.status_code === 200) {
        const fileArry = res.data.split('/uploads/');
        this.apiService.getBlobFileFromServer(res.data).subscribe(res => {
          this.appComponent.hideLoader();
          let blob:any = new Blob([res], { type: res.type });
          const url = window.URL.createObjectURL(blob);
          let file_name = fileArry[fileArry.length - 1];
          saveAs(blob, file_name);
        }, (error) => {
          this.appComponent.hideLoader();
        });
      }
      this.appComponent.hideLoader();
    }, (error) => {
      this.appComponent.hideLoader();
      console.log('error' , error);
    });
  }
}
